/* eslint-disable react-hooks/rules-of-hooks */
// 3rd party libraries
import Prismic from '@prismicio/client'
import { RichText, RichTextBlock } from 'prismic-reactjs'
import SliceZone from 'next-slicezone'
import { useGetStaticProps, useGetStaticPaths } from 'next-slicezone/hooks'
// Services&Helper functions
import resolver from '../../sm-resolver.js'
// Styles
import s from '../../styles/pages/Advices.module.scss'
// Components
import { Container } from '../../components/core/container/Container'
import { Section } from '../../components/core/section/Section'
import { Text } from '../../components/core/text/Text'
import Meta from '../../components/meta/Meta'
import { useState } from 'react'
import RandomArticles from '../../components/components/randomArticles/RandomArticles'
import ShareModal from '../../components/components/share/Share'
import { Button } from '../../components/core/button/Button'
import { RandomCTO } from '../../components/components/randomCTO/index'
import helperFunctions from '../../utils/helperFunctions'

// Fetch content from prismic
export const getStaticProps = useGetStaticProps({
    // @ts-ignore
    client: Prismic.client('https://minningar.cdn.prismic.io/api/v2'),
    type: 'blog',
    apiParams({ params }) {
        // params are passed by getStaticPaths
        return {
            lang: params.lang,
            uid: params.uid,
        }
    },
})

// fetch all docs of type `page` and pass params accordingly
export const getStaticPaths = useGetStaticPaths({
    // @ts-ignore
    client: Prismic.client('https://minningar.cdn.prismic.io/api/v2'),
    type: 'blog',
    formatPath: (prismicDocument: { lang: any; uid: any }) => {
        return {
            params: {
                lang: prismicDocument.lang,
                uid: prismicDocument.uid,
            },
        }
    },
})

type Props = JSX.IntrinsicAttributes & {
    uid: string
    data: {
        titill: RichTextBlock[]
        [keys: string]: any
    }
    first_publication_date: string
}

const Page = (props: Props) => {
    const [openModal, setOpenModal] = useState(false)
    const date = helperFunctions.getDate(new Date(props.first_publication_date))

    return (
        <>
            <Section>
                <Meta
                    title="Minningar - Hagnýtar upplýsingar"
                    seoTitle={`Minningar - ${
                        props.data.sharetitle ||
                        RichText.asText(props.data.titill)
                    }`}
                    description={`${props.data.sharedescription || ''}`}
                    url={`https://minningar.is/advice/${props.uid}`}
                    image={props.data.shareimage?.url}
                    type="website"
                />
                <Container className={s.header}>
                    <Text variant="date" className={s.header__date}>
                        {date}
                    </Text>
                    <Text variant="h1" className={s.header__item}>
                        {RichText.asText(props.data.titill)}
                    </Text>
                </Container>
            </Section>

            <SliceZone {...props} resolver={resolver} />
            <Container>
                <Button
                    className={s.share}
                    variant="arrow"
                    icon="share"
                    onClick={() => setOpenModal(true)}
                >
                    Deila
                </Button>
            </Container>
            <ShareModal
                setOpenModal={setOpenModal}
                url={`https://minningar.is/advice/${props.uid}`}
                isOpen={openModal}
            />
            <RandomArticles />
            <RandomCTO />
        </>
    )
}

export default Page
